import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Alert
} from '@mui/material';

import api from '../../api/axios';

const CompaniesPage = () => {

  const [companies, setCompanies] = useState([]);

  const [name, setName] = useState('');
  const [adminUsername, setAdminUsername] = useState('');
  const [adminPassword, setAdminPassword] = useState('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // ✅ FETCH COMPANIES
  const fetchCompanies = async () => {
    try {
      const res = await api.get('/super-admin/companies');
      setCompanies(res.data);
    } catch (err) {
      console.error(err);
      setError('Failed to load companies');
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  // ✅ CREATE COMPANY + ADMIN
  const handleCreate = async () => {

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await api.post('/super-admin/companies', {
        name,
        adminUsername,
        adminPassword
      });

      setSuccess('Company + Admin created successfully');

      setName('');
      setAdminUsername('');
      setAdminPassword('');

      fetchCompanies();

    } catch (err) {
      console.error(err);
      setError(err.response?.data || 'Error creating company');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4 }}>

      <Typography variant="h4" fontWeight={800} mb={3}>
        🏢 Company Management
      </Typography>

      {/* ================= CREATE ================= */}
      <Paper sx={{ p: 3, mb: 4 }}>

        <Typography variant="h6" mb={2}>
          Create Company + Owner
        </Typography>

        <Grid container spacing={2}>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Company Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Owner Username"
              value={adminUsername}
              onChange={(e) => setAdminUsername(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Owner Password"
              type="password"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={handleCreate}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Create Company'}
            </Button>
          </Grid>

        </Grid>

        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}

      </Paper>

      {/* ================= TABLE ================= */}
      <Paper sx={{ p: 3 }}>

        <Typography variant="h6" mb={2}>
          All Companies
        </Typography>

        <Table>

          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Plan</TableCell>
              <TableCell>Max Employees</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {companies.map((c) => (
              <TableRow key={c.id}>
                <TableCell>{c.id}</TableCell>
                <TableCell>{c.name}</TableCell>
                <TableCell>{c.status}</TableCell>
                <TableCell>{c.subscriptionPlan}</TableCell>
                <TableCell>{c.maxEmployees}</TableCell>
              </TableRow>
            ))}
          </TableBody>

        </Table>

      </Paper>

    </Box>
  );
};

export default CompaniesPage;